import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useOrganization } from '../../contexts/OrganizationContext';
import InventoryLayout from './InventoryLayout';
import PlatformText from '../PlatformText';
import PlatformButton from '../PlatformButton';
import InventoryBackButton from './InventoryBackButton';
import { getPlatformClass } from '../../utils/platformUtils';
import { useTranslation } from '../../hooks/useTranslation';

function SettingsPage() {
  const navigate = useNavigate();
  const platformClass = getPlatformClass();
  const isMobilePlatform = platformClass.includes('ios') || platformClass.includes('android') || platformClass.includes('pwa');
  const { t } = useTranslation('inventory');

  return (
    <InventoryLayout>
      <div className={`inventory-container ${platformClass}`}>
        {/* Mobile App Bar */}
        {isMobilePlatform && (
          <div className="mobile-app-bar inventory-mobile-app-bar">
            <InventoryBackButton onClick={() => navigate('/inventory')}>{t('settings.title')}</InventoryBackButton>
          </div>
        )}

        {/* Desktop Header */}
        {!isMobilePlatform && (
          <div className="inventory-page-header">
            <div>
              <InventoryBackButton onClick={() => navigate('/inventory')}>{t('settings.title')}</InventoryBackButton>
              <PlatformText variant="body" className="inventory-page-subtitle">
                {t('settings.settingsSubtitle')}
              </PlatformText>
            </div>
          </div>
        )}

        <div className="inventory-empty-container">
          <h3>{t('settings.settingsTitle')}</h3>
          <p>{t('settings.settingsDescription')}</p>
          <PlatformButton onClick={() => navigate('/inventory')}>
            {t('settings.backToDashboard')}
          </PlatformButton>
        </div>
      </div>
    </InventoryLayout>
  );
}

export default SettingsPage; 